import React from "react";

import styles from "./Hero.module.scss";

export const Hero = function ({ scrollTo }) {
  return (
    <section id="form" className={styles.hero}>
      <div className={styles.heroContainer}>
        <h1>
          CYBERSECURITY: MANAGING RISK
          <br />
          IN THE INFORMATION AGE
        </h1>
        <small>ONLINE SHORT COURSE</small>
        <p>
          <em>In collaboration with leaders in online education, GetSmarter</em>
        </p>
        <button onClick={scrollTo} id="cta-scroll">
          GET MORE INFORMATION
        </button>
      </div>
    </section>
  );
};
